import * as types from '../mutation-types'
import api from '@/api/customSection'

// initial state
const state = {
    contentSection: {},
    wholeContentSection: {},
    loaded: false,
}

const getters = {
    contentSection: state => state.contentSection,
    wholeContentSection: state => state.wholeContentSection,
    contentSectionLoaded: state => state.loaded,
}

const actions = {
    getContentSection({ commit }, payload) {
        commit(types.SET_CONTENT_SECTION_LOADED, false );
        api.getContentSection(payload.id, payload.query, (response) => {
            commit(types.SET_CONTENT_SECTION, response );
            if(payload.query && !payload.query.solutionsIdCategories) {
                commit(types.SET_WHOLE_CONTENT_SECTION, response );
            }
            commit(types.SET_CONTENT_SECTION_LOADED, true );
        })
    },
}

const mutations = {
    [types.SET_CONTENT_SECTION] (state, section ) {
        state.contentSection = section
    },
    [types.SET_WHOLE_CONTENT_SECTION] (state, section ) {
        state.wholeContentSection = section
    },
    [types.SET_CONTENT_SECTION_LOADED] (state, status ) {
        state.loaded = status
    },
}


export default {
    state,
    getters,
    actions,
    mutations
}


